import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function Support() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <nav className="container">
          <Link to="/" className="back-link">← 返回首页</Link>
        </nav>
      </header>
      <div className="container">
        <h1>技术支持</h1>
        <p className="last-updated">最后更新：2026年4月9日</p>

        <section className="legal-section">
          <h2>支持的应用</h2>
          <p>本页面用于为杭州斯代拉科技有限公司开发和发布的移动应用提供技术支持服务。</p>
          <ul>
            <li><strong>应用名称：</strong>压缩工坊</li>
            <li><strong>支持内容：</strong>图片压缩、PDF 压缩、保存导出、分享结果、会员与恢复购买</li>
            <li><strong>支持平台：</strong>iPhone、iPad</li>
          </ul>
          <p className="legal-note"><strong>Support URL：</strong>你可以将此页面地址作为 App Store Connect 中的技术支持网址。</p>
        </section>

        <section className="legal-section">
          <h2>联系我们</h2>
          <p>如果你在使用过程中遇到问题，可以通过以下方式联系我们：</p>
          <ul>
            <li><strong>公司名称：</strong>杭州斯代拉科技有限公司</li>
            <li><strong>联系电话：</strong>15000416741</li>
            <li><strong>客服 QQ：</strong>454784911</li>
            <li><strong>电子邮箱：</strong>454784911@qq.com</li>
            <li><strong>工作时间：</strong>周一至周五 9:00-18:00</li>
            <li><strong>公司地址：</strong>浙江省杭州市余杭区高教镇凤仪大道966号2号楼6层603室6414室</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>常见问题</h2>

          <h3>1. 为什么无法选择图片？</h3>
          <p>请确认你已经允许应用访问“照片”。如果此前拒绝过权限，请前往 iPhone 的“设置 &gt; 隐私与安全性 &gt; 照片”中重新授权。</p>

          <h3>2. 为什么无法保存压缩后的图片？</h3>
          <p>保存到照片需要“添加到照片”权限。如果保存失败，请检查系统授权状态后重试。</p>

          <h3>3. 为什么无法选择 PDF？</h3>
          <p>PDF 文件需要从系统“文件”中选择。请确认文件存在于“文件”App 可访问的位置，并且文件未损坏。</p>

          <h3>4. 为什么压缩后的 PDF 效果和原文件不完全一样？</h3>
          <p>压缩工坊会把页面重建为更轻的版本，因此更适合扫描件或图片型 PDF。对于包含复杂矢量内容的 PDF，压缩后的视觉效果可能与原文件存在差异。</p>

          <h3>5. 免费次数和会员有什么区别？</h3>
          <p>新用户可免费试用 3 次压缩。免费次数用完后，可开通永久会员继续使用图片和 PDF 压缩功能。</p>
        </section>

        <section className="legal-section">
          <h2>恢复购买</h2>
          <p>如果你已经购买永久会员，在更换设备后可以尝试按以下步骤恢复：</p>
          <ol>
            <li>在新设备上安装并打开压缩工坊。</li>
            <li>进入“我的”或会员页面。</li>
            <li>点击“恢复购买”。</li>
            <li>按系统提示使用与你购买时相同的 Apple 账户完成恢复。</li>
          </ol>
          <p>如果恢复后权益没有同步，请把问题发生时间、设备型号、系统版本和购买账号对应的 Apple 订单截图发送给我们，我们会协助排查。</p>
        </section>

        <section className="legal-section">
          <h2>问题反馈建议</h2>
          <p>为了更快定位问题，建议反馈时尽量附上以下信息：</p>
          <ul>
            <li>应用名称和问题页面</li>
            <li>iPhone 或 iPad 机型</li>
            <li>iOS 系统版本</li>
            <li>问题发生时间</li>
            <li>问题截图或录屏</li>
            <li>如果与购买有关，请附上 App Store 订单截图</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>隐私与政策</h2>
          <p>如需查看隐私政策、服务条款或退款政策，可访问以下页面：</p>
          <ul>
            <li><Link to="/privacy">隐私政策</Link></li>
            <li><Link to="/terms">服务条款</Link></li>
            <li><Link to="/refund">退款政策</Link></li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Support;
